$('.li-size, .li-color').on('mouseenter', function () {
  if (!$(this).hasClass('selected')) {
    if ($(this).hasClass('li-color')) {
      $(this).find('img').css('border', '2px solid #fe893a');
      $(this).parent().find('.selected img').css('border', '2px solid #fff');
    } else {
      $(this).css('border', '2px solid #fe893a');
      $(this).parent().find('.selected').css('border', '2px solid #dddddd'); 
    }
  }
}).on('mouseleave', function () {
  if ($(this).hasClass('li-color')) {
    $(this).find('img').css('border', '2px solid #fff');
    $(this).parent().find('.selected img').css('border', '2px solid #fe893a');
  } else {
    $(this).css('border', '2px solid #dddddd');
    $(this).parent().find('.selected').css('border', '2px solid #fe893a');
  }
});